// Every photo on the site, in one place. Files live in public/images/photos
// as <name>-800.webp plus a large size (1600w unless `large` says otherwise).
// `pos` is the focal point (object-position) used when a layout crops the photo.
//
// All of these are real photographs by Bright Kwame Ayisi, taken at a junior
// high school in Tapa Amanya, Oti Region, Ghana (June 2024), released CC0 on
// Wikimedia Commons. They show the communities EMANAC serves; they are not
// EMANAC programme photos, so never caption the people as our learners.
// Swap in EMANAC's own photos here when they exist.

export const PHOTO_CREDIT = {
  name: "Bright Kwame Ayisi",
  place: "Tapa Amanya, Oti Region, Ghana",
  href: "https://commons.wikimedia.org/wiki/User:Kwameghana",
};

export const PHOTOS = {
  heroLaptop: {
    file: "hero-laptop-outdoors", large: 2400, w: 1600, h: 1065,
    alt: "Six students in school uniform gather around a laptop on a wooden desk under a tree, one smiling at the camera.",
  },
  computerLab: {
    file: "computer-lab", w: 1600, h: 1065,
    alt: "A group of students crowd around a desktop computer, one typing on the keyboard while the others watch closely.",
  },
  smilingClassroom: {
    file: "smiling-classroom", pos: "60% 45%", w: 1600, h: 1065,
    alt: "Two students laughing at their wooden classroom desk, with classmates seated behind them.",
  },
  playingAmpe: {
    file: "playing-ampe", pos: "50% 45%", w: 1600, h: 1065,
    alt: "Schoolgirls jumping and laughing as they play ampe on the grass outside their school.",
  },
  girlsLaptop: {
    file: "girls-laptop", w: 1600, h: 1063,
    alt: "Four girls in school uniform stand outdoors reading something on a laptop together.",
  },
  girlsLaptopPointing: {
    file: "girls-laptop-pointing", pos: "50% 35%", w: 1600, h: 1055,
    alt: "A girl points at a laptop screen while three classmates look on, outdoors under the trees.",
  },
  mentorLab: {
    file: "mentor-lab", w: 1600, h: 1065,
    alt: "A mentor leans over three students in a computer room, pointing at something on a monitor.",
  },
  twoFriendsTall: {
    file: "two-friends-tall", large: 1000, w: 1000, h: 1502,
    alt: "Two smiling schoolgirls look up from an open exercise book on their desk.",
  },
  laptopIndoors: {
    file: "laptop-indoors", pos: "50% 40%", w: 1600, h: 1065,
    alt: "Students lean in together around a laptop in a computer room, one pointing at the screen.",
  },
  studentPortrait: {
    file: "student-portrait", w: 1600, h: 1102,
    alt: "A smiling student rests her chin on her hand at a classroom desk, classmates seated behind her.",
  },
  readingTogether: {
    file: "reading-together", pos: "50% 22%", w: 1600, h: 1065,
    alt: "Three students stand in front of a chalkboard reading a textbook together.",
  },
};
